export default "__VITE_ASSET__3SaU8Mnw__"